import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

import product from '@/store/shared/product'
import list from '@/store/shared/selectableList'
import search from '@/store/shared/search'

export default{
  namespaced: true,
  state () {
    return {
      vendor: undefined,
      description: undefined,
      amount: undefined,
      loaded: false
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    edit: product,
    list,
    search
  }
}
